export default "__VITE_ASSET__IWIXKlnw__"